import {
  BubbleContainer,
  BubbleOuterDiv,
  SubtitleText,
} from "./ServiceBubble.styles";

interface Props {
  label: string;
  backgroundColor?: string;
  position: "flex-start" | "center" | "flex-end";
  // position: string;
}

const ServiceBubble = ({ label, position, backgroundColor }: Props) => {
  return (
    <BubbleOuterDiv position={position}>
      <BubbleContainer backgroundColor={backgroundColor}>
        <SubtitleText> {label}</SubtitleText>
      </BubbleContainer>
    </BubbleOuterDiv>
  );
};

export default ServiceBubble;
